import { from, Observable } from "rxjs";
import { apiClient } from "./api";
import { ENDPOINTS } from "@/settings/api-settings";
import { map } from "rxjs/operators";
import { FeriadoFiltroParmDTO, FeriadoParmDTO } from "@/interfaces/calendar";

export function listCalendarHolidays(filter: FeriadoFiltroParmDTO): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CALENDAR_HOLIDAYS, filter)).pipe(
    map((r: any) => r.data),
  );
}

export function getCalendarHoliday(id: number): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.CALENDAR_HOLIDAYS}/${id}`)).pipe(
    map((r: any) => r.data),
  );
}

export function saveCalendarHoliday(parm: FeriadoParmDTO): Observable<any> {
  return from(apiClient.post(ENDPOINTS.CALENDAR_HOLIDAYS, parm)).pipe(
    map((r: any) => r.data),
  );
}

export function updateCalendarHoliday(parm: FeriadoParmDTO): Observable<any> {
  return from(apiClient.put(ENDPOINTS.CALENDAR_HOLIDAYS, parm)).pipe(
    map((r: any) => r.data),
  );
}

export function deleteCalendarHoliday(id: number): Observable<any> {
  return from(apiClient.delete(`${ENDPOINTS.CALENDAR_HOLIDAYS}/${id}`)).pipe(
    map((r: any) => r.data),
  );
}